const slugify = (str) => str.normalize("NFC").toLowerCase().trim().replace(/[^\p{L}\p{M}\p{N}\s-]/gu, "").replace(/[\s-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 255);
const slugifyJoin = (child, parent) => {
  return [parent, child].join("__");
};
function deduplicateSlugs({
  slug,
  slugs,
  limit = 100
}) {
  const used = new Set(slugs);
  if (!used.has(slug)) return slug;
  let i = 1;
  while (i < limit && used.has(`${slug}-${i}`)) i++;
  return `${slug}-${i}`;
}
function uidUniqueSlugs(records, nameKey) {
  const names = {};
  const nameCount = {};
  records.forEach((record) => {
    const name = slugify(record[nameKey]);
    names[record.uid] = nameCount[name] ? `${name}-${nameCount[name]}` : name;
    nameCount[name] = nameCount[name] ? nameCount[name] + 1 : 1;
  });
  return names;
}
export {
  deduplicateSlugs,
  slugify,
  slugifyJoin,
  uidUniqueSlugs
};
//# sourceMappingURL=slugify.js.map
